import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { PortalService } from './core/portal.service';

/** Partners only; anyone else signs in, or finishes setting up, first. */
const partnerGuard = async () => {
  const portal = inject(PortalService);
  const router = inject(Router);
  await portal.whenReady();
  if (portal.isPartner()) return true;
  return router.parseUrl(portal.user() ? '/join' : '/login?next=/dashboard');
};

// Titles are keys into the dictionary's `titles` (TranslatedTitles in app.config).
export const routes: Routes = [
  { path: '', loadComponent: () => import('./pages/hub/hub.component').then(m => m.HubComponent), title: 'home' },
  { path: 'hotels', loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent), title: 'hotels' },
  ...(['resellers', 'creators', 'custom'] as const).map(kind => ({
    path: kind,
    loadComponent: () => import('./pages/partner-type/partner-type.component').then(m => m.PartnerTypeComponent),
    data: { kind },
    title: kind,
  })),
  { path: 'posters', loadComponent: () => import('./pages/studio/studio.component').then(m => m.StudioComponent), title: 'posters' },
  { path: 'join', loadComponent: () => import('./pages/join/join.component').then(m => m.JoinComponent), title: 'join' },
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent), title: 'login' },
  { path: 'dashboard', canActivate: [partnerGuard], loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent), title: 'dashboard' },
  { path: 'terms', loadComponent: () => import('./pages/terms/terms.component').then(m => m.TermsComponent), title: 'terms' },
  // Old portal paths, still in emails and bookmarks.
  { path: 'partner', redirectTo: 'dashboard' },
  { path: 'partner/terms', redirectTo: 'terms' },
  { path: 'partner/marketing', redirectTo: 'posters' },
  { path: 'partner/marketing/poster', redirectTo: 'posters' },
  { path: 'partner/**', redirectTo: 'dashboard' },
  { path: 'become-a-partner', redirectTo: '' },
  { path: 'become-a-partner/**', redirectTo: '' },
  { path: '**', redirectTo: '' },
];
